<template>
    <div id="group_detail" v-if="status.show">
        <div class="main_between cross_top" style="margin-bottom: 25px;">
            <div class="left_col">
                <div class="left_cont">
                    <h3 style="font-weight: bold;margin-bottom: 1em;font-size: 18px;">
                        {{ currQcrode.name }}
                    </h3>
                    <a-form :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }" labelAlign="left">
                        <a-form-item label="创建人">
                            <openData type="userName" :openid="currQcrode.owner"></openData>
                        </a-form-item>
                        <a-form-item label="引导语">
                            {{ currQcrode.guide ? currQcrode.guide : '-' }}
                        </a-form-item>
                        <a-form-item label="活动场景">
                            {{ currQcrode.scene ? currQcrode.scene : '-' }}
                        </a-form-item>
                        <a-form-item label="含群数量">
                            {{ currQcrode.number ? currQcrode.number : 0 }}
                        </a-form-item>
                        <a-form-item label="创建时间">
                            {{ currQcrode.createTime ? currQcrode.createTime : '-' }}
                        </a-form-item>
                    </a-form>
                    <a-divider />
                    <div>
                        <a-space>
                            <a-button @click="toStatus(5)">管理群聊</a-button>
                            <a-button @click="toStatus(4)">编辑</a-button>
                            <a-button @click="deleteGroupQrcode(currQcrode)">删除</a-button>
                        </a-space>
                    </div>
                </div>
            </div>
            <div class="right_col">
                <!-- <img :src="currQcrode.qrcode" width="100%" height="260" />
                <div class="main_center cross_center" style="margin-top: 15px;">
                    <a-button-group>
                        <a-button
                            type="link"
                            size="small"
                            @click="downloadImg(currQcrode)"
                            >下载群码</a-button
                        >
                        <a-divider type="vertical" />
                        <a-button
                            type="link"
                            size="small"
                            @click="toCopy(currQcrode)"
                            >复制链接</a-button
                        >
                    </a-button-group>
                </div> -->
                <createQrcode :fileName="currQcrode.name" :data="qrcodeParams"></createQrcode>
            </div>
        </div>
        <a-table
            rowKey="id"
            :columns="currDetailStatus.columns"
            :data-source="currDetailStatus.list"
            :pagination="currDetailStatus.page"
            @change="changePagination"
        >
            <template slot="qrcode" slot-scope="text">
                <a-tooltip placement="right">
                    <template slot="title">
                        <img :src="text" width="100%" />
                    </template>
                    <a-avatar :src="text" size="small" shape="square" />
                </a-tooltip>
            </template>
            <template slot="outTime" slot-scope="record">
                {{ record.distanceTime }}
            </template>
        </a-table>
    </div>
</template>

<script>
import api from '@/apis';
import _ from 'lodash';
import dayjs from 'dayjs';
import openData from '@/components/group/openData';
import createQrcode from '@/components/group/createQrcode';
export default {
    // 群聊管理组件
    name: 'group_chat_manage',
    props: {
        // 当前群码信息
        currQcrode: {
            type: Object,
            default: () => {}
        },
        // 当前页状态参数
        status: {
            type: Object,
            default: () => {}
        }
    },
    components: {
        openData,
        createQrcode
    },
    data() {
        return {
            currDetailStatus: {
                // 群聊表格数据
                columns: [
                    {
                        title: '群二维码',
                        dataIndex: 'qrcode',
                        scopedSlots: { customRender: 'qrcode' }
                    },
                    {
                        title: '群名称',
                        dataIndex: 'name'
                    },
                    {
                        title: '群人数',
                        dataIndex: 'number'
                    },
                    {
                        title: '群二维码有效期截止',
                        dataIndex: 'endTime'
                    },
                    {
                        title: '距离过期',
                        scopedSlots: { customRender: 'outTime' }
                    }
                ],
                list: [],
                page: {
                    total: 0,
                    pageSize: 10
                },
                params: {
                    page: 1,
                    keywords: null
                },
                loading: false
            },
            qrcodeUrl: process.env.VUE_APP_DEFAULT + '/html/tool/qrcode?groupId=',
            qrcodeParams: {
                qid: '1',
                correctLevel: 3,
                text: '未设置内容',
                logoSrc: '',
                logoScale: 0.2,
                logoMargin: 2,
                size: 260,
                margin: 10
            }
        };
    },
    created() {},
    computed: {},
    mounted() {
        if (this.status.show) {
            this.getEnterCrodeList(this.currQcrode);
            // 赋值二维码参数
            if (this.currQcrode && this.currQcrode.groupId) {
                this.qrcodeParams.qid = this.currQcrode.groupId;
                this.qrcodeParams.text = this.qrcodeUrl + this.currQcrode.groupId;
            }
            if (this.currQcrode && this.currQcrode.logo)
                this.qrcodeParams.logoSrc = this.currQcrode.logo;
        }
    },
    methods: {
        dayjs,
        // 去群聊管理
        toStatus(num) {
            this.currQcrode.chat = this.currDetailStatus.list[0] || {};
            if (num) this.$emit('toChat', num, this.currQcrode);
        },
        // 删除群码
        async deleteGroupQrcode(record) {
            const that = this;
            if (!record || (record && !record.id)) return that.$message.error(`未获取当前群聊信息`);
            const params = {
                groupCodeId: record.id
            };
            try {
                this.$confirm({
                    title: `确认删除群聊？`,
                    icon: 'info-circle',
                    async onOk() {
                        const res = await api.deleteGroupQrcode(params);
                        if (res.code !== 0) return that.$message.error(`删除群聊报错`);
                        that.$message.success('删除成功');
                        that.$emit('backStatus', that.status);
                    },
                    onCancel() {}
                });
            } catch (err) {
                console.log(err);
            }
        },
        // 下载图片
        async downloadImg(record) {
            if (!record || !record.id) return this.$message.error('下载员工码传参错误。');
            try {
                const res = await api.downloadGroupQrcode({ groupId: record.id });
                if (!res) return;
                if (record.qrcode) {
                    const arr = record.qrcode.split('.');
                    const format = '.' + arr[arr.length - 1];
                    this.downImgFile(record.name + format, res);
                } else {
                    return this.$message.error('群码还没生成');
                }
            } catch (err) {
                console.log(err);
            }
        },
        // 文件流下载方法
        downImgFile(file_name, content) {
            const csvData = new Blob([content]);
            // for IE
            if (window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(csvData, file_name);
            }
            // for Non-IE (chrome, firefox etc.)
            else {
                let a = document.createElement('a');
                document.body.appendChild(a);
                a.style = 'display: none';
                const url = window.URL.createObjectURL(csvData);
                a.href = url;
                a.download = file_name;
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
            }
        },
        // 复制
        toCopy(data) {
            //创建一个 Input标签
            let oInput = document.createElement('input');
            oInput.value = data.qrcode;
            document.body.appendChild(oInput);
            oInput.select(); // 选择对象;
            console.log(oInput.value);
            // 执行浏览器复制命令
            /// 复制命令会将当前选中的内容复制到剪切板中
            /// 如这里构建的 Input标签
            document.execCommand('Copy');
            this.$message.success('复制成功！');
            ///复制成功后再将构造的标签 移除
            oInput.remove();
        },
        // 获取企业微信群码列表
        async getEnterCrodeList(listData) {
            try {
                if (!listData || (listData && !listData.groupId))
                    return this.$message.error(`未获取当前群码信息`);
                if (!this.currDetailStatus) return this.$message.error(`未获取当状态信息`);
                const curStatus = this.currDetailStatus;
                const params = {
                    groupId: listData.groupId
                };
                if (curStatus && curStatus.params.page >= 1) params.page = curStatus.params.page;
                if (curStatus && curStatus.params.keywords)
                    params.keywords = curStatus.params.keywords;
                const res = await api.getEnterCrodeList(params);
                if (res.code !== 0) return this.$message.error(`获取企业微信群码列表报错`);
                res.rows.forEach((item) => {
                    item.distanceTime = this.animation(dayjs(item.endTime));
                    return item;
                });
                curStatus.list = res.rows;
                curStatus.page = {
                    total: res.count,
                    pageSize: res.pageSize
                };
            } catch (err) {
                console.log(err);
            }
        },
        // 翻页
        changePagination(pagination, filters, sorter, currentDataSource) {
            const curr = this.currDetailStatus;
            // 群聊翻页
            curr.params.page = pagination.current;
            this.getEnterCrodeList(this.currQcrode);
        },
        // 倒计时
        animation(endDate) {
            const _ms = endDate.diff(dayjs());
            if (_ms > 0) {
                const _dd = endDate.diff(dayjs(), 'day');
                const _hh = endDate.diff(dayjs(), 'hour');
                const _mm = endDate.diff(dayjs(), 'minute');
                const _ss = endDate.diff(dayjs(), 'second');

                // 转换
                const hh = _hh - _dd * 24;
                const mm = _mm - _hh * 60;
                const ss = _ss - _mm * 60;
                const ms = _ms - _ss * 1000;

                // 格式化
                const DD = ('00' + _dd).slice(-2);
                const HH = ('00' + hh).slice(-2);
                const MM = ('00' + mm).slice(-2);
                const SS = ('00' + ss).slice(-2);
                const MS = ('000' + ms).slice(-3);
                if (DD !== '00') {
                    return DD + '天 ' + HH + '：' + MM + '：' + SS;
                } else {
                    return HH + '：' + MM + '：' + SS;
                }
            } else {
                return '已过期';
            }
        }
    }
};
</script>

<style>
#group_detail {
    max-height: calc(100vh - 305px);
    overflow-x: hidden;
    overflow-y: auto;
}
#group_detail .left_col {
    padding: 0 6% 0 0;
    width: calc(95% - 260px);
}
#group_detail .right_col {
    width: 260px;
}
#group_detail .ant-form-item {
    margin-bottom: 0;
}
#group_detail .ant-form-item label {
    color: #909399 !important;
}
</style>
